import get from 'lodash/get';

export const getReviewCusInfo = (customerInfo = {}) => ([
  {
    id: 'Customer Basic Info',
    itemList: [
      {
        label: 'CUST_CUSTOMER_TYPE', // Customer Type
        value: get(customerInfo, 'custBasicInfo.custType'),
      },
      {
        label: 'CUST_PAID_FLAG', // Pre/post paid
        value: get(customerInfo, 'custBasicInfo.paidFlag'),
      },
      {
        label: 'REVIEW_TITLE', // Title
        value: get(customerInfo, 'custBasicInfo.title'),
      },
      {
        label: 'REVIEW_FULL_NAME', // Full Name
        value: get(customerInfo, 'custBasicInfo.fullName'),
      },
      {
        label: 'CUST_GENDER', // Gender
        value: get(customerInfo, 'custBasicInfo.gender'),
      },
      {
        label: 'CUST_DATE_OF_BIRTH', // Date of Birth
        value: get(customerInfo, 'custBasicInfo.dateOfBirthForReview'),
      },
      {
        label: '',
        value: '',
      },
      {
        label: '',
        value: '',
      },
    ],
  },
  {
    formTitle: 'CUST_POI',
    id: 'Proof of Identity Details',
    itemList: [
      {
        label: 'BUSINESS_DOCUMENT_TYPE',
        value: get(customerInfo, 'custBasicInfo.custCertValue.certTypeName'),
      },
      {
        label: 'BUSINESS_DOCUMENT_NUMBER', // Mobile Number
        value: get(customerInfo, 'custBasicInfo.custCertValue.certNbr'),
      },
      {
        label: 'BUSINESS_EFF_DATE',
        value: get(customerInfo, 'custBasicInfo.custCertValue.effDateForReview'),
      },
      {
        label: 'BUSINESS_EXP_DATE',
        value: get(customerInfo, 'custBasicInfo.custCertValue.expDateForReview'),
      },
      {
        label: 'BUSINESS_ISSUE_ORG',
        value: get(customerInfo, 'custBasicInfo.custCertValue.issueOrg'),
      },
      {
        label: ' ',
        value: ' ',
      },
      {
        label: 'ADDR_PROOF_FILE',
        value: get(customerInfo, 'custBasicInfo.poiDto'),
        hasImg: true,
      },
    ],
  },
]);
